/**
 * ¿El mensaje promete un archivo? (M24, auditoría 2026-10-02)
 *
 * Antes se buscaba /adjunt|anex|attach/ en TODO el editor y en el asunto: al
 * responder, la cita del correo original («te adjunto la factura») disparaba el
 * aviso aunque la persona no prometiera nada, y «te mando el PDF» no lo disparaba.
 */
const PROMETE_ARCHIVO = new RegExp([
  '\\b(adjunt|anex|attach)',
  '\\b(te|les?|os) (mando|envío|envio|paso|comparto|reenvío|reenvio)\\b[^.\\n]{0,30}\\b(archivo|documento|pdf|foto|fotos|imagen|imágenes|factura|contrato|cotizaci[oó]n|presupuesto|excel|hoja|presentaci[oó]n|zip)',
  '\\bva(n)? (el|la|los|las) (archivo|documento|pdf|fotos?|factura|contrato)',
  '\\b(en|ver) el (archivo|documento|pdf) (que )?(te )?(mando|envío|envio|paso)',
].join('|'), 'i');

export function prometeArchivo(texto) {
  return PROMETE_ARCHIVO.test(String(texto || ''));
}

/** Lo que escribió la persona en el editor: sin la cita del original ni la firma. */
export function textoPropio(editor) {
  if (!editor) return '';
  const copia = editor.cloneNode(true);
  copia.querySelectorAll('blockquote, .zuno-signature').forEach((n) => n.remove());
  return copia.innerText ?? copia.textContent ?? '';
}
